/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';
import { FormErrors } from './FormErrors';
import Dropdowns from '../Filters/Dropdowns/Dropdowns';
import '../../Pages/Users/Users.css';

export default props => (

	<div>
		<form onSubmit={props.handleSubmit}>
			<div className="nameDesc">
				<div className="halfWidthCont unPw">
					<div className="inputGroup">
						<p>Username: </p>
						<input
							className="userInputs"
							type="text"
							name="userName"
							// required
							value={props.state.userName}
							onChange={props.handleInputChange}
						/>
					</div>
					{props.passwordInput ? <div className="inputGroup">
						<p>Password:</p>
						<input
							className="userInputs"
							type={props.state.showPassword ? 'text' : 'password'}
							name="password"
							// required
							value={props.state.password}
							onChange={props.handleInputChange}
						/>
						<div className="subGroup">
							<p className="showPw"> Show Password</p>
							<input
								className="cBox"
								type="checkbox"
								name="showPassword"
								value={props.state.showPassword}
								checked={props.state.showPassword}
								onChange={props.toggleShowPassword}
							/>
						</div>
					</div> : ''}
				</div>

				<div className="halfWidthCont fullName">
					<div className="inputGroup">
						<p>First Name: </p>
						<input
							className="userInputs"
							type="text"
							name="firstName"
							// required
							value={props.state.firstName}
							onChange={props.handleInputChange}
						/>
					</div>
					<div className="inputGroup">
						<p>Middle Name: </p>
						<input
							className="userInputs"
							type="text"
							name="middleName"
							// required
							value={props.state.middleName}
							onChange={props.handleInputChange}
						/>
					</div>
					<div className="inputGroup">
						<p>Last Name: </p>
						<input
							className="userInputs"
							type="text"
							name="lastName"
							// required
							value={props.state.lastName}
							onChange={props.handleInputChange}
						/>
					</div>
				</div>
				<div className="halfWidthCont">
					<div className="inputGroup">
						<p>Email: </p>
						<input
							className="userInputs"
							type="email"
							name="email"
							// required
							value={props.state.email}
							onChange={props.handleInputChange}
						/>
					</div>
				</div>
				<div className="halfWidthCont">
					<div className="inputGroup">
						<p>Protected: </p>
						<input
							type="checkbox"
							name="isProtected"
							// required
							value={props.state.isProtected}
							checked={props.state.isProtected}
							onChange={props.handleInputChange}
						/>
						<p>Active: </p>
						<input
							type="checkbox"
							name="isActive"
							// required
							value={props.state.isActive}
							checked={props.state.isActive}
							onChange={props.handleInputChange}
						/>
					</div>
				</div>
				<div className="halfWidthCont">
					<div className="inputGroup rolesGroup">
						<p>Roles:</p>
						<div className="rdMultiSelect">
							{

								JSON.parse(localStorage.getItem("isSuperman")) ?
									props.roles.length ?
										<CheckboxGroup name="roles" value={props.state.roles} onChange={props.handleCheckboxChange}>
											{  props.roles.map((item, i) => (
												<div key={i} className="optionGroup">
													<label>
														<Checkbox value={item} />
														{item}
													</label>
												</div>
											))}
										</CheckboxGroup>
										:
										<div> No Roles</div>

							  :
							  
							  props.roles.length ?
										<CheckboxGroup name="roles" value={props.state.roles} onChange={props.handleCheckboxChange}>
											{  props.roles.filter(item => item !== "Superman").map((item, i) => (
												<div key={i} className="optionGroup">
													<label>
														<Checkbox value={item} />
														{item}
													</label>
												</div>
											))}
										</CheckboxGroup>
										:
										<div> No Roles</div>

							}

						</div>
					</div>
				</div>
				<div className="halfWidthCont">
					<div className="inputGroup rolesGroup">
						<p>Notes: </p>
						<textarea
							className="userInputs userNotes"
							type="text"
							name="notes"
							// required
							value={props.state.notes}
							onChange={props.handleInputChange}
						/>
					</div>
				</div>
				<div className="halfWidthCont">
					<Dropdowns selectLabel={props.userGroup.label} items={props.userGroup.items} selectLabelHeader="true" onChange={props.userGroup.onChange}
						defaultValue={props.userGroup.userGroupId} placeholderName="User Group" form name="userGroupId" autoSelect
					/>
				</div>
				<FormErrors className={props.state.formErrors ? 'active' : ''} formErrors={props.state.formErrors} />
			</div>
			<div className="formControls">
				{/* <input disabled={!props.state.formValid} className="addSubmit" type="submit" > {props.addLabel ? 'Add User' : 'Edit User'} </input> */}
				<input  className="addSubmit" type="submit" value={props.addLabel ? "Add User" : "Save User"}/> 
				<Link className="addCancel" to="/users">Cancel</Link>
			</div>
		</form>

	</div>

);



// WEBPACK FOOTER //
// ./src/Components/Pages/UsersEditAddComponent.js